export default "__VITE_ASSET__50630be2__"